import useAppModal from 'hooks/useAppModal';
import { Integration } from 'models/InternalIntegrationSetting';
import { QueryKey } from '@tanstack/react-query';
import CustomIntegrationModal from './CustomIntegrationModal';
import { CUSTOM_INTEGRATION_ACTIVATION_MODAL_ID } from './CustomIntegrationModal.constants';

const useEnableCustomIntegrationModal = () => {
  const { openModal } = useAppModal();

  const openCustomIntegrationModal = ({
    integration,
    queryKey,
  }: {
    integration: Integration;
    queryKey: QueryKey;
  }) => {
    openModal({
      customContent: (
        <CustomIntegrationModal integration={integration} queryKey={queryKey} />
      ),
      id: CUSTOM_INTEGRATION_ACTIVATION_MODAL_ID,
      size: 'medium',
    });
  };

  return {
    openCustomIntegrationModal,
  };
};

export default useEnableCustomIntegrationModal;
